import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=35cd21b6"
import script from "./EditTaskModal.vue?vue&type=script&lang=ts"
export * from "./EditTaskModal.vue?vue&type=script&lang=ts"
import style0 from "./EditTaskModal.vue?vue&type=style&index=0&id=35cd21b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports